import { ComponentType } from 'react';

import { SectionTitleRow } from 'flow/components/nav/list-keys/list-key-action';
import { LIST_HEADER_ITEM_HEIGHT, LIST_ITEM_HEIGHT } from 'flow/flow-theme';
import { Channel } from 'flow/types/Channel';
import {
    AICoworker,
    Connection,
    QueueSortingData,
    Refer,
} from 'flow/types/Pbx';
import { TypedMap } from 'flow/types/TypedMap';
import { Voicemail } from 'flow/types/Voicemail';

export type PbxListDepartment =
    | 'supervisorView'
    | 'favorites'
    | 'ivr'
    | 'queues'
    | 'liveChats'
    | 'voicemails'
    | 'connections'
    | 'aiCoworkers';

export interface DepartmentState {
    favorites: boolean;
    refers: boolean;
    queues: boolean;
    channels: boolean;
    voicemails: boolean;
    connections: boolean;
    aiCoworkers: boolean;
}

export type PbxListItem = TypedMap<
    Channel | Connection | QueueSortingData | Refer | Voicemail | AICoworker
>;

// An item without a key renders nothing, so the arrow keys skip it.
export type PbxListRow =
    | (SectionTitleRow & { department: keyof DepartmentState; title: string })
    | {
          kind: 'item';
          key: string;
          department: string;
          item?: PbxListItem;
          Component: ComponentType<any>;
      }
    | { kind: 'unfocusable' };

export const pbxListRowHeight = (row: PbxListRow) =>
    row.kind === 'sectionTitle' ? LIST_HEADER_ITEM_HEIGHT : LIST_ITEM_HEIGHT;

// Names a row for the list: for react-window, and for the Tab stop, which keeps
// to its row through new rows. A favourite queue is also in its own section,
// and a search keeps both copies close together. So the key has the section.
export const pbxListRowKey = (row: PbxListRow) => {
    switch (row.kind) {
        case 'item':
            return `${row.department}:${row.key}`;
        case 'sectionTitle':
            return `section:${row.department}`;
        default:
            return null;
    }
};

export const rowIsFocusable = (row: PbxListRow) => {
    switch (row.kind) {
        case 'sectionTitle':
            return row.canToggle;
        case 'item':
            return true;
        default:
            return false;
    }
};
